import { staticText } from '../../utils/translations/staticText';

/**
 * Shared by every module that shows the personal-loan reward (CMS-1922 Table
 * Builder, CMS-1928 Quick Answer): CMS-1928 asks to reuse the prefix, not
 * duplicate it.
 */
export const LoanRewardPillTranslations = staticText({
  // The total is an upper bound, so it carries the qualifier; breakdowns do not.
  reward_up_to: {
    _: 'Up to',
    zh: '高達',
  },
});
